export const resetPasswordTranslations = {
  en: {
    'resetPassword.noToken': 'No reset token provided. Please use the link from your email.',
    'resetPassword.invalidToken': 'Invalid reset token format.',
    'resetPassword.validating': 'Validating reset link...',
    'resetPassword.invalidLink': 'Invalid Reset Link',
    'resetPassword.linkExpired': 'The password reset link you\'re trying to use is invalid or has expired.',
    'resetPassword.requestNewLink': 'Request New Reset Link',
    'resetPassword.backToLogin': 'Back to Login',
    'resetPassword.loggingIn': 'Logging you in automatically...',
    'resetPassword.passwordPlaceholder': 'Enter your new password',
    'resetPassword.confirmPlaceholder': 'Re-enter your new password',
    'resetPassword.strength': 'Password strength: {{strength}}',
    'resetPassword.match': '✓ Passwords match',
    'resetPassword.noMatch': '✗ Passwords do not match',
    'resetPassword.errors.newPasswordRequired': 'Please enter a new password',
    'resetPassword.errors.confirmPasswordRequired': 'Please confirm your password',
    'resetPassword.errors.passwordsMismatch': 'Passwords do not match',
    'resetPassword.errors.expired': 'This reset link has expired. Please request a new password reset.',
    'resetPassword.errors.invalid': 'This reset link is invalid. Please request a new password reset.',
    'resetPassword.errors.network': 'Unable to connect to server. Please check your connection and try again.',
  },
  es: {
    'resetPassword.noToken': 'No se proporcionó ningún token de restablecimiento. Utilice el enlace de su correo electrónico.',
    'resetPassword.invalidToken': 'Formato de token de restablecimiento no válido.',
    'resetPassword.validating': 'Validando enlace de restablecimiento...',
    'resetPassword.invalidLink': 'Enlace de Restablecimiento No Válido',
    'resetPassword.linkExpired': 'El enlace de restablecimiento de contraseña que intenta utilizar no es válido o ha caducado.',
    'resetPassword.requestNewLink': 'Solicitar Nuevo Enlace de Restablecimiento',
    'resetPassword.backToLogin': 'Volver a Iniciar Sesión',
    'resetPassword.loggingIn': 'Iniciando sesión automáticamente...',
    'resetPassword.passwordPlaceholder': 'Introduzca su nueva contraseña',
    'resetPassword.confirmPlaceholder': 'Vuelva a introducir su nueva contraseña',
    'resetPassword.strength': 'Fuerza de la contraseña: {{strength}}',
    'resetPassword.match': '✓ Las contraseñas coinciden',
    'resetPassword.noMatch': '✗ Las contraseñas no coinciden',
    'resetPassword.errors.newPasswordRequired': 'Por favor, introduzca una nueva contraseña',
    'resetPassword.errors.confirmPasswordRequired': 'Por favor, confirme su contraseña',
    'resetPassword.errors.passwordsMismatch': 'Las contraseñas no coinciden',
    'resetPassword.errors.expired': 'Este enlace de restablecimiento ha caducado. Por favor, solicite un nuevo restablecimiento de contraseña.',
    'resetPassword.errors.invalid': 'Este enlace de restablecimiento no es válido. Por favor, solicite un nuevo restablecimiento de contraseña.',
    'resetPassword.errors.network': 'No se puede conectar al servidor. Por favor, compruebe su conexión e inténtelo de nuevo.',
  },
  fr: {
    'resetPassword.noToken': 'Aucun token de réinitialisation fourni. Veuillez utiliser le lien de votre e-mail.',
    'resetPassword.invalidToken': 'Format de token de réinitialisation invalide.',
    'resetPassword.validating': 'Validation du lien de réinitialisation...',
    'resetPassword.invalidLink': 'Lien de réinitialisation invalide',
    'resetPassword.linkExpired': 'Le lien de réinitialisation de mot de passe que vous essayez d\'utiliser est invalide ou a expiré.',
    'resetPassword.requestNewLink': 'Demander un nouveau lien de réinitialisation',
    'resetPassword.backToLogin': 'Retour à la connexion',
    'resetPassword.loggingIn': 'Connexion automatique en cours...',
    'resetPassword.passwordPlaceholder': 'Entrez votre nouveau mot de passe',
    'resetPassword.confirmPlaceholder': 'Ré-entrez votre nouveau mot de passe',
    'resetPassword.strength': 'Force du mot de passe : {{strength}}',
    'resetPassword.match': '✓ Les mots de passe correspondent',
    'resetPassword.noMatch': '✗ Les mots de passe ne correspondent pas',
    'resetPassword.errors.newPasswordRequired': 'Veuillez entrer un nouveau mot de passe',
    'resetPassword.errors.confirmPasswordRequired': 'Veuillez confirmer votre mot de passe',
    'resetPassword.errors.passwordsMismatch': 'Les mots de passe ne correspondent pas',
    'resetPassword.errors.expired': 'Ce lien de réinitialisation a expiré. Veuillez demander une nouvelle réinitialisation de mot de passe.',
    'resetPassword.errors.invalid': 'Ce lien de réinitialisation est invalide. Veuillez demander une nouvelle réinitialisation de mot de passe.',
    'resetPassword.errors.network': 'Impossible de se connecter au serveur. Veuillez vérifier votre connexion et réessayer.',
  },
  sq: {
    'resetPassword.noToken': 'Nuk u dha token rikthimi. Ju lutemi përdorni lidhjen nga email-i juaj.',
    'resetPassword.invalidToken': 'Format i pavlefshëm i token-it të rikthimit.',
    'resetPassword.validating': 'Duke validuar lidhjen e rikthimit...',
    'resetPassword.invalidLink': 'Lidhje e Pavlefshme e Rikthimit',
    'resetPassword.linkExpired': 'Lidhja e rikthimit të fjalëkalimit që po përpiqeni të përdorni është e pavlefshme ose ka skaduar.',
    'resetPassword.requestNewLink': 'Kërkoni Lidhje të Re Rikthimi',
    'resetPassword.backToLogin': 'Kthehu te Hyrja',
    'resetPassword.loggingIn': 'Duke ju futur automatikisht...',
    'resetPassword.passwordPlaceholder': 'Shkruani fjalëkalimin tuaj të ri',
    'resetPassword.confirmPlaceholder': 'Rishkruani fjalëkalimin tuaj të ri',
    'resetPassword.strength': 'Forca e fjalëkalimit: {{strength}}',
    'resetPassword.match': '✓ Fjalëkalimet përputhen',
    'resetPassword.noMatch': '✗ Fjalëkalimet nuk përputhen',
    'resetPassword.errors.newPasswordRequired': 'Ju lutemi shkruani një fjalëkalim të ri',
    'resetPassword.errors.confirmPasswordRequired': 'Ju lutemi konfirmoni fjalëkalimin tuaj',
    'resetPassword.errors.passwordsMismatch': 'Fjalëkalimet nuk përputhen',
    'resetPassword.errors.expired': 'Kjo lidhje rikthimi ka skaduar. Ju lutemi kërkoni një rikthim të ri fjalëkalimi.',
    'resetPassword.errors.invalid': 'Kjo lidhje rikthimi është e pavlefshme. Ju lutemi kërkoni një rikthim të ri fjalëkalimi.',
    'resetPassword.errors.network': 'Nuk mund të lidhemi me serverin. Ju lutemi kontrolloni lidhjen tuaj dhe provoni përsëri.',
  },
  ru: {
    'resetPassword.noToken': 'Токен сброса не предоставлен. Пожалуйста, используйте ссылку из вашего email.',
    'resetPassword.invalidToken': 'Неверный формат токена сброса.',
    'resetPassword.validating': 'Проверка ссылки сброса...',
    'resetPassword.invalidLink': 'Неверная ссылка сброса',
    'resetPassword.linkExpired': 'Ссылка для сброса пароля, которую вы пытаетесь использовать, неверна или истекла.',
    'resetPassword.requestNewLink': 'Запросить новую ссылку сброса',
    'resetPassword.backToLogin': 'Вернуться к входу',
    'resetPassword.loggingIn': 'Автоматический вход...',
    'resetPassword.passwordPlaceholder': 'Введите новый пароль',
    'resetPassword.confirmPlaceholder': 'Повторно введите новый пароль',
    'resetPassword.strength': 'Надежность пароля: {{strength}}',
    'resetPassword.match': '✓ Пароли совпадают',
    'resetPassword.noMatch': '✗ Пароли не совпадают',
    'resetPassword.errors.newPasswordRequired': 'Пожалуйста, введите новый пароль',
    'resetPassword.errors.confirmPasswordRequired': 'Пожалуйста, подтвердите пароль',
    'resetPassword.errors.passwordsMismatch': 'Пароли не совпадают',
    'resetPassword.errors.expired': 'Эта ссылка сброса истекла. Пожалуйста, запросите новый сброс пароля.',
    'resetPassword.errors.invalid': 'Эта ссылка сброса неверна. Пожалуйста, запросите новый сброс пароля.',
    'resetPassword.errors.network': 'Не удалось подключиться к серверу. Проверьте подключение и попробуйте снова.',
  },

  de: {
    'resetPassword.noToken': 'Kein Reset-Token bereitgestellt. Bitte verwenden Sie den Link aus Ihrer E-Mail.',
    'resetPassword.invalidToken': 'Ungültiges Reset-Token-Format.',
    'resetPassword.validating': 'Reset-Link wird validiert...',
    'resetPassword.invalidLink': 'Ungültiger Reset-Link',
    'resetPassword.linkExpired': 'Der Passwort-Reset-Link, den Sie verwenden möchten, ist ungültig oder abgelaufen.',
    'resetPassword.requestNewLink': 'Neuen Reset-Link anfordern',
    'resetPassword.backToLogin': 'Zurück zur Anmeldung',
    'resetPassword.loggingIn': 'Sie werden automatisch angemeldet...',
    'resetPassword.passwordPlaceholder': 'Geben Sie Ihr neues Passwort ein',
    'resetPassword.confirmPlaceholder': 'Geben Sie Ihr neues Passwort erneut ein',
    'resetPassword.strength': 'Passwortstärke: {{strength}}',
    'resetPassword.match': '✓ Passwörter stimmen überein',
    'resetPassword.noMatch': '✗ Passwörter stimmen nicht überein',
    'resetPassword.errors.newPasswordRequired': 'Bitte geben Sie ein neues Passwort ein',
    'resetPassword.errors.confirmPasswordRequired': 'Bitte bestätigen Sie Ihr Passwort',
    'resetPassword.errors.passwordsMismatch': 'Passwörter stimmen nicht überein',
    'resetPassword.errors.expired': 'Dieser Reset-Link ist abgelaufen. Bitte fordern Sie einen neuen Passwort-Reset an.',
    'resetPassword.errors.invalid': 'Dieser Reset-Link ist ungültig. Bitte fordern Sie einen neuen Passwort-Reset an.',
    'resetPassword.errors.network': 'Verbindung zum Server nicht möglich. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  },

  sr: {
    'resetPassword.noToken': 'Није дат токен за ресетовање. Молимо користите линк из вашег имејла.',
    'resetPassword.invalidToken': 'Неважећи формат токена за ресетовање.',
    'resetPassword.validating': 'Провера линка за ресетовање...',
    'resetPassword.invalidLink': 'Неважећи линк за ресетовање',
    'resetPassword.linkExpired': 'Линк за ресетовање лозинке који покушавате да користите је неважећи или је истекао.',
    'resetPassword.requestNewLink': 'Затражите нови линк за ресетовање',
    'resetPassword.backToLogin': 'Назад на пријаву',
    'resetPassword.loggingIn': 'Аутоматско пријављивање...',
    'resetPassword.passwordPlaceholder': 'Унесите вашу нову лозинку',
    'resetPassword.confirmPlaceholder': 'Поново унесите вашу нову лозинку',
    'resetPassword.strength': 'Јачина лозинке: {{strength}}',
    'resetPassword.match': '✓ Лозинке се подударају',
    'resetPassword.noMatch': '✗ Лозинке се не подударају',
    'resetPassword.errors.newPasswordRequired': 'Молимо унесите нову лозинку',
    'resetPassword.errors.confirmPasswordRequired': 'Молимо потврдите вашу лозинку',
    'resetPassword.errors.passwordsMismatch': 'Лозинке се не подударају',
    'resetPassword.errors.expired': 'Овај линк за ресетовање је истекао. Молимо затражите ново ресетовање лозинке.',
    'resetPassword.errors.invalid': 'Овај линк за ресетовање је неважећи. Молимо затражите ново ресетовање лозинке.',
    'resetPassword.errors.network': 'Није могуће повезати се са сервером. Проверите везу и покушајте поново.',
  },
  pl: {
    'resetPassword.noToken': 'Nie podano tokena resetującego. Proszę użyć linku z Twojego emaila.',
    'resetPassword.invalidToken': 'Nieprawidłowy format tokena resetującego.',
    'resetPassword.validating': 'Walidowanie linku resetującego...',
    'resetPassword.invalidLink': 'Nieprawidłowy Link Resetujący',
    'resetPassword.linkExpired': 'Link resetujący hasło, którego próbujesz użyć, jest nieprawidłowy lub wygasł.',
    'resetPassword.requestNewLink': 'Poproś o Nowy Link Resetujący',
    'resetPassword.backToLogin': 'Powrót do Logowania',
    'resetPassword.loggingIn': 'Automatyczne logowanie...',
    'resetPassword.passwordPlaceholder': 'Wprowadź swoje nowe hasło',
    'resetPassword.confirmPlaceholder': 'Wprowadź ponownie swoje nowe hasło',
    'resetPassword.strength': 'Siła hasła: {{strength}}',
    'resetPassword.match': '✓ Hasła się zgadzają',
    'resetPassword.noMatch': '✗ Hasła się nie zgadzają',
    'resetPassword.errors.newPasswordRequired': 'Proszę wprowadzić nowe hasło',
    'resetPassword.errors.confirmPasswordRequired': 'Proszę potwierdzić swoje hasło',
    'resetPassword.errors.passwordsMismatch': 'Hasła się nie zgadzają',
    'resetPassword.errors.expired': 'Ten link resetujący wygasł. Proszę poprosić o nowe resetowanie hasła.',
    'resetPassword.errors.invalid': 'Ten link resetujący jest nieprawidłowy. Proszę poprosić o nowe resetowanie hasła.',
    'resetPassword.errors.network': 'Nie można połączyć się z serwerem. Sprawdź połączenie i spróbuj ponownie.',
  },
  el: {
    'resetPassword.noToken': 'Δεν παρέχεται διακριτικό επαναφοράς. Παρακαλώ χρησιμοποιήστε τον σύνδεσμο από το email σας.',
    'resetPassword.invalidToken': 'Μη έγκυρη μορφή διακριτικού επαναφοράς.',
    'resetPassword.validating': 'Επαλήθευση συνδέσμου επαναφοράς...',
    'resetPassword.invalidLink': 'Μη Έγκυρος Σύνδεσμος Επαναφοράς',
    'resetPassword.linkExpired': 'Ο σύνδεσμος επαναφοράς κωδικού πρόσβασης που προσπαθείτε να χρησιμοποιήσετε είναι μη έγκυρος ή έχει λήξει.',
    'resetPassword.requestNewLink': 'Ζητήστε Νέο Σύνδεσμο Επαναφοράς',
    'resetPassword.backToLogin': 'Επιστροφή στη Σύνδεση',
    'resetPassword.loggingIn': 'Σύνδεση αυτόματα...',
    'resetPassword.passwordPlaceholder': 'Εισάγετε τον νέο σας κωδικό πρόσβασης',
    'resetPassword.confirmPlaceholder': 'Εισάγετε ξανά τον νέο σας κωδικό πρόσβασης',
    'resetPassword.strength': 'Ισχύς κωδικού πρόσβασης: {{strength}}',
    'resetPassword.match': '✓ Οι κωδικοί πρόσβασης ταιριάζουν',
    'resetPassword.noMatch': '✗ Οι κωδικοί πρόσβασης δεν ταιριάζουν',
    'resetPassword.errors.newPasswordRequired': 'Παρακαλώ εισάγετε έναν νέο κωδικό πρόσβασης',
    'resetPassword.errors.confirmPasswordRequired': 'Παρακαλώ επιβεβαιώστε τον κωδικό πρόσβασής σας',
    'resetPassword.errors.passwordsMismatch': 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
    'resetPassword.errors.expired': 'Αυτός ο σύνδεσμος επαναφοράς έχει λήξει. Παρακαλώ ζητήστε μια νέα επαναφορά κωδικού πρόσβασης.',
    'resetPassword.errors.invalid': 'Αυτός ο σύνδεσμος επαναφοράς είναι μη έγκυρος. Παρακαλώ ζητήστε μια νέα επαναφορά κωδικού πρόσβασης.',
    'resetPassword.errors.network': 'Δεν είναι δυνατή η σύνδεση με τον διακομιστή. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
  },
  ro: {
    'resetPassword.noToken': 'Nu este furnizat tokenul de resetare. Vă rugăm folosiți linkul din email-ul dvs.',
    'resetPassword.invalidToken': 'Format token de resetare invalid.',
    'resetPassword.validating': 'Se validează linkul de resetare...',
    'resetPassword.invalidLink': 'Link de Resetare Invalid',
    'resetPassword.linkExpired': 'Linkul de resetare a parolei pe care încercați să îl folosiți este invalid sau a expirat.',
    'resetPassword.requestNewLink': 'Solicită Link Nou de Resetare',
    'resetPassword.backToLogin': 'Înapoi la Autentificare',
    'resetPassword.loggingIn': 'Vă autentificăm automat...',
    'resetPassword.passwordPlaceholder': 'Introduceți noua parolă',
    'resetPassword.confirmPlaceholder': 'Reintroduceți noua parolă',
    'resetPassword.strength': 'Putere parolă: {{strength}}',
    'resetPassword.match': '✓ Parolele se potrivesc',
    'resetPassword.noMatch': '✗ Parolele nu se potrivesc',
    'resetPassword.errors.newPasswordRequired': 'Vă rugăm introduceți o parolă nouă',
    'resetPassword.errors.confirmPasswordRequired': 'Vă rugăm confirmați parola',
    'resetPassword.errors.passwordsMismatch': 'Parolele nu se potrivesc',
    'resetPassword.errors.expired': 'Acest link de resetare a expirat. Vă rugăm solicitați o nouă resetare a parolei.',
    'resetPassword.errors.invalid': 'Acest link de resetare este invalid. Vă rugăm solicitați o nouă resetare a parolei.',
    'resetPassword.errors.network': 'Nu se poate conecta la server. Vă rugăm verificați conexiunea și încercați din nou.',
  },
  pt: {
    'resetPassword.noToken': 'Nenhum token de redefinição fornecido. Use o link do seu email.',
    'resetPassword.invalidToken': 'Formato de token de redefinição inválido.',
    'resetPassword.validating': 'Validando link de redefinição...',
    'resetPassword.invalidLink': 'Link de Redefinição Inválido',
    'resetPassword.linkExpired': 'O link de redefinição de senha que você está tentando usar é inválido ou expirou.',
    'resetPassword.requestNewLink': 'Solicitar Novo Link de Redefinição',
    'resetPassword.backToLogin': 'Voltar para Login',
    'resetPassword.loggingIn': 'Fazendo login automaticamente...',
    'resetPassword.passwordPlaceholder': 'Digite sua nova senha',
    'resetPassword.confirmPlaceholder': 'Digite novamente sua nova senha',
    'resetPassword.strength': 'Força da senha: {{strength}}',
    'resetPassword.match': '✓ As senhas coincidem',
    'resetPassword.noMatch': '✗ As senhas não coincidem',
    'resetPassword.errors.newPasswordRequired': 'Por favor, digite uma nova senha',
    'resetPassword.errors.confirmPasswordRequired': 'Por favor, confirme sua senha',
    'resetPassword.errors.passwordsMismatch': 'As senhas não coincidem',
    'resetPassword.errors.expired': 'Este link de redefinição expirou. Solicite uma nova redefinição de senha.',
    'resetPassword.errors.invalid': 'Este link de redefinição é inválido. Solicite uma nova redefinição de senha.',
    'resetPassword.errors.network': 'Não é possível conectar ao servidor. Verifique sua conexão e tente novamente.',
  },
};
